import checkField from './checkField.js'

/**
 * Legacy alias over the generic `checkField` guard.
 *
 *   condition: { type: 'array', array: 'reservations' }
 *
 * Prefer `checkField` with `{ field, operator: 'empty' }` for new guards — it works
 * on any field type and supports the full operator set.
 */
const emptyArray = (condition, data) =>
    checkField({ field: condition?.array, operator: 'empty' }, data)

export default emptyArray
